exports.default = {
  'title': '资产',
  'files_count': '{count} 个文件',
  'folder_unit': '个文件夹',
  'all_assets': '全部资产',
  'folder': '文件夹',
  'default_space': '默认空间',
  'new_folder': '新建文件夹',
  'create_folder_hint': '整理你的资产',
  'folder_actions': '文件夹操作',
  'add_content': '添加内容',
  'upload_file': '上传文件',
  'upload_image_video': '上传图片/视频',
  'unsupported_upload_type': '“{name}”不是支持的图片或视频格式，已跳过',
  'upload_to': '上传到',
  'selected_folder': '选择位置',
  'upload_folder_search': '搜索文件夹',
  'no_folder_match': '没有匹配的文件夹',
  'choose_upload_folder': '请选择上传文件夹',
  'uploading': '上传中',
  'upload_waiting': '等待上传',
  'upload_complete': '上传完成',
  'upload_failed': '上传失败',
  'upload_success': '上传成功',
  'upload_partial': '{count} 个文件上传失败',
  'batch_operation': '批量操作',
  'exit_batch': '退出批量操作',
  'selected_assets': '已选择资产',
  'batch_limit': '单次最多选择 {count} 个资产',
  'batch_download': '批量下载',
  'batch_download_success': '已开始下载 {count} 个文件',
  'batch_download_partial': '已开始下载 {success} 个文件，{failed} 个文件失败',
  'download_started': '已开始下载',
  'download': '下载',
  'preview': '预览',
  'preview_unavailable': '该文件暂不支持在线预览',
  'loading_preview': '正在准备预览',
  'preview_back': '返回文件夹',
  'preview_failed': '预览加载失败，请重试或下载文件',
  'preview_retry': '重新加载',
  'more_actions': '更多操作',
  'rename': '重命名',
  'delete': '删除',
  'move': '移动',
  'refresh': '刷新',
  'loading_more': '正在加载更多...',
  'search': '搜索',
  'filter': '筛选',
  'keyword_placeholder': '关键词搜索',
  'type_filter': '类型筛选',
  'type_all': '全部类型',
  'type_image': '图片',
  'type_video': '视频',
  'type_audio': '音频',
  'type_other': '其他',
  'date_filter': '日期筛选',
  'filter_date': '筛选日期',
  'filter_date_hint': '按创建时间筛选资产',
  'date_all': '全部时间',
  'date_today': '今天',
  'date_recent_5': '最近 5 天',
  'date_recent_15': '最近 15 天',
  'date_recent_30': '最近 30 天',
  'custom_date': '自定义范围',
  'start_date': '开始日期',
  'end_date': '结束日期',
  'reset': '重置',
  'apply': '应用',
  'sort_by_update': '按更新时间排序',
  'newest_first': '最近更新',
  'oldest_first': '最早更新',
  'no_assets': '这里还没有资产',
  'no_filter_results': '没有匹配的资产',
  'try_other_filters': '请调整筛选条件后重试',
  'upload_to_start': '上传文件后，它们会出现在这里',
  'folder_name': '文件夹名称',
  'folder_name_placeholder': '请输入文件夹名称',
  'folder_name_required': '请输入文件夹名称',
  'folder_unavailable': '该文件夹不存在或已被删除',
  'rename_folder': '重命名文件夹',
  'delete_folder': '删除文件夹',
  'confirm_delete_folder': '确定删除文件夹“{name}”吗？',
  'folder_not_empty': '该文件夹包含 {count} 个文件，请选择处理方式',
  'delete_folder_files': '删除文件后删除文件夹',
  'move_folder_files': '移动文件后删除文件夹',
  'confirm_delete': '确认删除',
  'move_assets': '移动资产',
  'move_assets_count': '将 {count} 个资产移动到：',
  'target_folder': '选择目标文件夹',
  'rename_file': '重命名文件',
  'file_name': '文件名称',
  'file_name_required': '请输入文件名称',
  'confirm_delete_asset': '确定删除“{name}”吗？',
  'confirm_delete_selected': '确定删除选中的 {count} 个资产吗？',
  'file_too_large': '“{name}”超过 50 MB，已跳过',
  'image_file_too_large': '图片“{name}”超过 20 MB，已跳过',
  'operation_success': '操作成功',
  'operation_failed': '操作失败，请稍后重试',
  'load_failed': '资产加载失败，请稍后重试',
  'total_items': '共 {count} 个文件',
  'visibility': '可见范围',
  'visibility_private': '私有',
  'visibility_team': '团队共享',
  'change_visibility_confirm': '确定将可见范围改为“{visibility}”吗？'
}
